
import { useAvatarUpload } from "./avatar/useAvatarUpload";
import { AvatarDisplay } from "./avatar/AvatarDisplay";
import { AvatarUploadButton } from "./avatar/AvatarUploadButton";
import { Profile } from "@/integrations/supabase/types";

interface AvatarUploaderProps {
  profile: Profile | null;
}

export function AvatarUploader({ profile }: AvatarUploaderProps) {
  // Custom hooks to separate logic
  const { 
    uploading, 
    avatarUrl, 
    uploadAvatar, 
    removeAvatar 
  } = useAvatarUpload(profile);

  return (
    <div className="flex flex-col items-center space-y-4">
      {/* Avatar display with remove button */}
      <AvatarDisplay 
        avatarUrl={avatarUrl} 
        profile={profile} 
        onRemove={removeAvatar} 
        isUploading={uploading} 
      />
      
      {/* Upload button and info */}
      <AvatarUploadButton 
        avatarUrl={avatarUrl} 
        onUpload={uploadAvatar} 
        isUploading={uploading} 
      />
    </div>
  );
}
